<template>
  <div class="painpoint">
    <div class="header">
      <div class="title">行业痛点 物业难题</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <div class="item" v-for="item in painpointList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import painpoint1 from "../../../../assets/product/painpoint1.png";
import painpoint2 from "../../../../assets/product/painpoint2.png";
import painpoint3 from "../../../../assets/product/painpoint3.png";
import painpoint4 from "../../../../assets/product/painpoint4.png";
import painpoint5 from "../../../../assets/product/painpoint5.png";

export default {
  setup() {
    return reactive({
      painpointList: [
        {
          id: 1,
          title: "物业收费难",
          text: "物企普遍存在的最大问题就是收费困难",
          logo: painpoint1,
        },
        {
          id: 2,
          title: "物企盈利难",
          text: "物业运营和管理成本高，人力成本居高不下且不断提升。",
          logo: painpoint2,
        },
        {
          id: 3,
          title: "物企响应慢",
          text: "物企工作人员工作效率较低，工作主动性不够高。",
          logo: painpoint3,
        },
        {
          id: 4,
          title: "物企管理缺乏",
          text: "大部分物企还未形成完整、系统的管理体系，缺乏有效的制度来规范管理流程。",
          logo: painpoint4,
        },
        {
          id: 5,
          title: "业主满意度低",
          text: "业主与物企矛盾尖锐，沟通存在困难。",
          logo: painpoint5,
        },
      ],
    });
  },
};
</script>

<style scoped>
.painpoint {
  width: 1180px;
  margin: 80px auto;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body .list {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
}
.body .list .item {
    width: 180px;
    text-align: center;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
    width: 180px;
}
.body .list .item .title {
    font-size: 18px;
    margin-top: 33px;
}
.body .list .item .text {
    color: #495A6C;
    font-size: 14px;
    margin-top: 8px;
    line-height: 24px;
}
</style>
